module.exports = __webpack_public_path__ + "img/comment-purple.ede4c708.svg";